import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { apiPost, apiPut } from '../../utils/apiFetch'
import apiPath from '../../utils/apiPath'
import OSelect from '../../components/reusable/OSelect'
import AuthContext from 'context/AuthContext'

const RecruiterModal = ({
  setShowModal,
  fetchRecruiters,
  item = null,
}) => {
  const { t } = useTranslation()
  const { user } = useContext(AuthContext)
  const permission = user?.permission?.find((p) => p.manager === 'careers')
  const canEdit = permission?.add || user?.role === 'admin'
  const isEdit = Boolean(item?._id)

  const [form, setForm] = useState({
    name: item?.name || '',
    status: item?.status || 'active',
  })
  const [saving, setSaving] = useState(false)

  useEffect(() => {
    setForm({
      name: item?.name || '',
      status: item?.status || 'active',
    })
  }, [item])

  const close = () => setShowModal(false)

  const save = async () => {
    if (!canEdit || !form.name.trim()) return
    setSaving(true)
    try {
      const payload = {
        name: form.name.trim(),
        status: form.status,
      }
      const res = isEdit
        ? await apiPut(`${apiPath.careerRecruiterById}/${item._id}`, payload)
        : await apiPost(apiPath.careerRecruiters, payload)
      if (res?.data?.success) {
        await fetchRecruiters()
        close()
      }
    } finally {
      setSaving(false)
    }
  }

  return (
    <>
      <div className='justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none'>
        <div className='relative my-6 w-full max-w-lg mx-auto'>
          <div className='sm:py-4 sm:px-2 py-8 px-7'>
            <div className='border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none'>
              <div className='flex items-center justify-between p-5 border-b border-solid border-slate-200 rounded-t'>
                <h3 className='text-xl font-semibold'>
                  {isEdit
                    ? t('Edit Recruiter') || 'Edit Recruiter'
                    : t('Add Recruiter') || 'Add Recruiter'}
                </h3>
                <button
                  type='button'
                  className='ml-auto flex items-center justify-center text-black border-2 rounded-full h-8 w-8 float-right text-3xl leading-none font-extralight outline-none focus:outline-none'
                  onClick={close}
                >
                  <span className='text-[#B8BBBF] text-4xl' title='Close'>
                    ×
                  </span>
                </button>
              </div>

              <div className='relative p-6 flex-auto'>
                <div className='grid gap-4'>
                  <div>
                    <label className='block mb-2 text-sm font-medium text-gray-900'>
                      {t('O_FULL_NAME') || 'Name'}{' '}
                      <sup className='text-red-500'>*</sup>
                    </label>
                    <input
                      className='bg-gray-50 border border-gray-300 text-sm rounded-lg p-2.5 w-full'
                      value={form.name}
                      disabled={!canEdit}
                      onChange={(e) =>
                        setForm({ ...form, name: e.target.value })
                      }
                      placeholder={t('Enter name') || 'Enter name'}
                      autoFocus
                    />
                  </div>

                  {isEdit ? (
                    <div>
                      <OSelect
                        inputLabel={t('O_STATUS')}
                        name='status'
                        register={{
                          name: 'status',
                          onChange: (e) =>
                            setForm({ ...form, status: e.target.value }),
                        }}
                        errors={{}}
                        disabled={!canEdit}
                        options={[
                          { value: 'active', key: t('active') || 'active' },
                          {
                            value: 'inactive',
                            key: t('inactive') || 'inactive',
                          },
                        ]}
                        value={form.status}
                        wrapperClassName='w-full'
                      />
                    </div>
                  ) : null}
                </div>
              </div>

              <div className='flex items-center justify-end gap-3 p-6 border-t border-solid border-slate-200 rounded-b'>
                <button
                  type='button'
                  className='px-4 py-2.5 rounded border border-gray-300 bg-white text-gray-700'
                  onClick={close}
                >
                  {t('O_BACK') || t('O_CANCEL') || 'Cancel'}
                </button>
                {canEdit ? (
                  <button
                    type='button'
                    className='px-4 py-2.5 rounded bg-[#8FC150] hover:bg-[#7eae43] text-white disabled:opacity-50'
                    disabled={saving || !form.name.trim()}
                    onClick={save}
                  >
                    {saving
                      ? t('Saving...') || 'Saving...'
                      : isEdit
                        ? t('SAVE') || t('Save') || 'Save'
                        : t('O_ADD') || 'Add'}
                  </button>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='opacity-25 fixed inset-0 z-40 bg-black'></div>
    </>
  )
}

export default RecruiterModal
